import * as yup from "yup"; 

// Función para validar CUIT / CUIL (formato argentino)
const validarCUIT = (cuit) => {
  if (!/^\d{11}$/.test(cuit)) return false;

  const coef = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
  const digits = cuit.split('').map(Number);
  const sum = digits.slice(0, 10).reduce((acc, val, idx) => acc + val * coef[idx], 0);
  let checkDigit = 11 - (sum % 11);
  if (checkDigit === 11) checkDigit = 0;
  if (checkDigit === 10) checkDigit = 9;

  return checkDigit === digits[10];
};

export const validation = yup.object().shape({
  td_id: yup
    .string()
    .required("El tipo de documento es obligatorio"),

  cli_cuit: yup
    .string()
    .required("El número de documento es obligatorio")
    .when("td_id", {
      is: "2", // DNI
      then: (schema) =>
        schema.matches(/^\d{8}$/, "El DNI debe tener exactamente 8 dígitos numéricos"),
    })
    .when("td_id", {
      is: "1", // CUIT
      then: (schema) =>
        schema.test("is-valid-cuit", "El CUIT no es válido", (value) => validarCUIT(value)),
    })
    .when("td_id", {
      is: "3", // CUIL
      then: (schema) =>
        schema.test("is-valid-cuil", "El CUIL no es válido", (value) => validarCUIT(value)),
    }),

  cli_mail: yup
    .string()
    .email("El correo electrónico no es válido"),

  cli_tel: yup
    .string()
    .nullable()
    .matches(
      /^\+?[0-9]{8,15}$/,
      "El teléfono debe tener entre 8 y 15 dígitos y puede incluir '+' al inicio"
    ),

  cli_direccion: yup
    .string()
    .nullable()
    .min(3, "La dirección debe tener al menos 3 caracteres")
    .max(25, "La dirección es demasiado larga"),

  cli_nro_calle: yup
    .string()
    .nullable()
    .matches(/^\d+$/, "El número de calle debe ser numérico"),

  cli_piso: yup
    .string()
    .nullable()
    .max(2, "El piso no puede tener más de 2 caracteres"),

  cli_dpto: yup
    .string()
    .nullable()
    .max(5, "El departamento no puede tener más de 5 caracteres"),

  cli_cp: yup
    .string()
    .nullable()
    .matches(/^\d{4,10}$/, "El código postal debe tener entre 4 y 10 dígitos"),

  cli_direccion_observ: yup
    .string()
    .nullable()
    .max(100, "La observación no puede tener más de 250 caracteres"),
});
